const getters = {
  currentStep: state => state.widget.currentStep,
  isClosed: state => state.widget.isClosed,
  jobRole: state => state.widget.data.jobRole.type,
  jobRoleText: state => state.widget.data.jobRole.value,
  businessType: state => state.widget.data.businessType,
  isSubmitStep: state => state.widget.isSubmitStep,
  submittingStatus: state => state.widget.submittingStatus
}

export default getters;
